<template>
  <div class="defaultSwagbagFile-list" v-if="isPageReady">
    <Action-panel :isReady="isPageReady">
      <div>
        <Button-base
          :type="2"
          :text="translations.labels.button_add_content"
          :hoverInfo="translations.labels.button_add_content_hover"
          :onClick="newItem"
        />
      </div>
    </Action-panel>
    <v-card class="ma-6">
      <v-tabs v-model="selectedTab" flat color="primary">
        <v-tab
          v-for="tab in languages"
          :key="tab.id"
          :href="`#tab-${tab.id}`"
          centered
          icons-and-text
        >
          {{ tab.description }}
        </v-tab>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item
            v-for="tab in languages"
            :key="tab.id"
            :value="`tab-${tab.id}`"
          >
            <v-card :isReady="isPageReady">
              <TableList
                :is-ready="model.length > 0"
                :headers="headers"
                :items="model.filter((l) => l.idLanguage === tab.id)[0].items"
                :items-per-page="-1"
                sortable
                hideFooter
                item-key="id"
                :searchVisible="false"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
    <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import ConfirmDialog from "@/components/dom/ConfirmDialog";
import Vue from "vue";
import Component from "vue-class-component";
import { toastService } from "@/services/toastService.js";
import Container from "@/components/dom/Container";
import ActionPanel from "@/components/panel/ActionPanel";
import InnerPanel from "@/components/panel/InnerPanel";
import TablePanel from "@/components/panel/TablePanel";
import ButtonBase from "@/components/dom/ButtonBase";
import SvgIcon from "@/components/dom/SvgIcon";
import Round from "@/components/dom/Round";
import TableList from "@/components/table/TableList";

@Component({
  inject: {
    eventService: "eventService",
    defaultSwagbagFileService: "defaultSwagbagFileService",
    categoryService: "categoryService",
    uiService: "uiService",
  },
  components: {
    ActionPanel,
    InnerPanel,
    TablePanel,
    ConfirmDialog,
    ButtonBase,
    SvgIcon,
    Round,
    Container,
    TableList
  }
})
export default class DefaultSwagbagFileList extends Vue {
  isPageReady = false;
  model = [];
  languages = [];
  categories = [];
  selectedTab = null;
  ui = {};


  newItem() {
    this.$router.push(
      `/swagbag/list/${this.$route.params.id}/new`
    );
  }

  async del(id) {
    if (
      await this.$refs.confirm.open(
        this.translations.confirmDialog.title,
        this.translations.confirmDialog.message
      )
    ) {
      try {
        await this.defaultSwagbagFileService.remove(id);
        this.loadData();
      } catch (error) {
        toastService.error(this.translations.errors.somethingWrong);
      }
    }
  }

  async loadData() {
    this.isPageReady = false;
    this.model = [];
    const contents = await this.defaultSwagbagFileService.list(
      this.$route.params.id
    );
    if (this.languages != undefined)
      this.languages.forEach((lang) => {
        this.model.push({
          idLanguage: lang.id,
          items: contents
            .filter((e) => e.idLanguage === lang.id)
            .map((c) => {
              return {
                id: c.id,
                name: c.name,
                assignmentPolicy: this.formatAssignmentPolicy(c.assignmentPolicy),
                uri: c.uri,
                description: c.description,
              };
            }),
        });
      });
    this.isPageReady = true;
  }

  formatAssignmentPolicy(assignmentPolicy){
    switch(assignmentPolicy){
      case "AllUsers":
        return this.translations.labels.swagbag_assignmentPolicy_allUsers;
      case "UsersAssigned":
        return this.translations.labels.swagbag_assignmentPolicy_usersAssigned;
      case "VisitorLevel":
        return this.translations.labels.swagbag_assignmentPolicy_visitorLevels;
    }
  }

  async loadLanguages() {
    this.languages = await this.eventService.relatedLanguages(
      this.$route.params.id
    );
  }

  async loadCategories() {
    this.categories = await this.categoryService.list();
  }

  async init() {
    try {
      await this.loadLanguages();
      await this.loadData();
    } catch (error) {
      toastService.error(this.translations.errors.somethingWrong);
    }
  }
  get translations() {
    return this.$store.state.translationsStore.currentLang;
  }
  get toolbarTitle() {
    return this.translations.labels.prefilled_swagbag;
  }
  get headers() {
    return [
      {
        text: this.translations.labels.swagbag_name,
        value: "name",
        sortable: false
      },
      {
        text: this.translations.labels.swagbag_assignmentPolicy,
        value: "assignmentPolicy",
        sortable: false,
      },
      {
        text: this.translations.labels.swagbag_uri,
        value: "uri",
        sortable: false,
        align: this.$route.params.type !== "HtmlContent" ? null : " d-none",
      },
      {
        text: this.translations.labels.table_delete,
        value: "delete",
        sortable: false,
        type: "action",
        icon: "mdi-delete",
        onAction: (item) => {
          this.del(item.id);
        },
      },
      {
        text: this.translations.labels.table_edit,
        value: "edit",
        sortable: false,
        type: "link",
        formatValue: (item) => {
          return `/swagbag/list/${this.$route.params.id}/edit/${item.id}`;
        },
        icon: "mdi-pencil",
        buttonType: 2,
      },
    ];
  }

  mounted() {
    this.init();
    this.$store.commit(
      "SET_SECTION_TITLE",
      this.translations.labels.prefilled_swagbag
    );
  }
}
</script>
<style lang="scss" scoped>
.defaultSwagbagFile-list {
  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px 30px 0 30px;
    margin: 15px 30px 0 30px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #2196f3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
}
</style>
